// NPM
import React, { useState, useEffect, useMemo } from "react";
import _ from "lodash";

// State
import { useDispatch } from "react-redux";
import { setPartyOrder } from "features/parties/partyOrderSlice";
import { useSelector } from "react-redux";

// Services
import apiService from "services/apiService";

// Services
import renderService from "services/renderService";

// Components
import VoteShareTile from "./VoteShareTile";
import { setVoteShare } from "../../features/voteShare/voteShareSlice";
import { usePartyOrder } from "../../hooks/usePartyOrder";
import { useEmbed } from "../../hooks/useEmbed";

function VoteShare() {
  const dispatch = useDispatch();
  const isEmbedded = useEmbed();
  const region = useSelector((state) => state.region.value);
  const voteShareData = useSelector((state) => state.voteShare.value);
  const campaignConfig = useSelector((state) => state.campaignConfig.value);
  const { orderedParties } = usePartyOrder();

  useEffect(() => loadData(), []);

  const loadData = async () => {
    const response = await fetch(apiService.apiURL("vote_share"));
    const jsonData = await response.json();
    dispatch(setVoteShare(jsonData));
  };

  const currentRegionShare = _.chain(voteShareData)
    .filter(
      (ssd) =>
        ssd.region === region &&
        ![ssd.median, ssd.lower, ssd.upper].includes("NA"),
    )
    .sortBy((ssd) => orderedParties.indexOf(ssd.party))
    .value();

  if (!renderService.canRender([campaignConfig, voteShareData])) {
    return null;
  }

  const title = _.get(campaignConfig, "sections.VoteShare.title");
  const description = _.get(campaignConfig, "sections.VoteShare.description");

  return (
    <div
      className={`VoteShare Signal__section ${isEmbedded ? "embedded" : ""}`}
    >
      {!isEmbedded && (
        <>
          {title && <h2 className="Signal__section-title">{title}</h2>}
          {description && (
            <p className="Signal__section-description">{description}</p>
          )}
        </>
      )}

      <div className="Signal__section-visualization">
        {currentRegionShare.map((voteShare, idx) => {
          return (
            <VoteShareTile key={`VoteShare-${idx}`} voteShare={voteShare} />
          );
        })}
      </div>
    </div>
  );
}

export default VoteShare;
